import { render, staticRenderFns } from "./StdButton.vue?vue&type=template&id=57d0e9b4&scoped=true&lang=html&"
import script from "./StdButton.vue?vue&type=script&lang=js&"
export * from "./StdButton.vue?vue&type=script&lang=js&"
import style0 from "./StdButton.vue?vue&type=style&index=0&id=57d0e9b4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0e9b4",
  null
  
)

export default component.exports